const custom_profile_fields = {
    /** UNTRANSLATED */
    entity_not_exists_with_names: 'Cannot find entities with the given names: {{names}}',
    invalid_min_max_input: '최소값과 최대값 입력이 올바르지 않습니다.',
    invalid_options: '필드 옵션이 올바르지 않습니다.',
    invalid_regex_format: '정규식 형식이 올바르지 않습니다.',
    invalid_address_parts: '주소 구성 요소가 올바르지 않습니다.',
    invalid_fullname_parts: '이름 구성 요소가 올바르지 않습니다.',
    name_exists: '해당 이름의 필드가 이미 존재합니다.',
    conflicted_sie_order: 'Sign-in Experience 용 필드 순서 값이 충돌합니다.',
    /** UNTRANSLATED */
    invalid_name: 'Invalid field name, only letters or numbers are allowed, case sensitive.',
};
export default Object.freeze(custom_profile_fields);
